import { render, staticRenderFns } from "./TooltipSchutzraum.vue?vue&type=template&id=9ba9f98e&scoped=true&"
import script from "./TooltipSchutzraum.vue?vue&type=script&lang=js&"
export * from "./TooltipSchutzraum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba9f98e",
  null
  
)

export default component.exports